import Vue from 'vue';

Vue.filter('formatNumber', value => [value].toLocaleString('sr-Latn-ME', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}));

Vue.filter('formatDate', (value) => {
  const date = new Date(value);
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();

  if (day < 10) {
    day = `0${day}`;
  }
  if (month < 10) {
    month = `0${month}`;
  }

  const formattedDate = `${day}.${month}.${year}.`;
  return formattedDate;
});

Vue.filter('formatTime', (value) => {
  const date = new Date(value);
  let hours = date.getHours();
  let minutes = date.getMinutes();

  if (hours < 10) {
    hours = `0${hours}`;
  }
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  const formattedTime = `${hours}:${minutes}`;
  return formattedTime;
});
